<template>
  <div>
    <bread-crumb path="反馈管理" subPath="反馈列表"></bread-crumb>
    <el-card>
      <el-table
        :data="feedbackList"
        stripe
        border
        :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="80px"></el-table-column>
        <el-table-column prop="member_id" label="用户ID" align="center" width="100px"></el-table-column>
        <el-table-column prop="member_name" label="用户名" align="center" width="160px"></el-table-column>
        <el-table-column label="反馈内容" align="left" min-width="320px">
          <template slot-scope="scope">
            <div class="feedback-content">{{ scope.row.content }}</div>
          </template>
        </el-table-column>
        <el-table-column label="反馈时间" align="center" width="180px">
          <template slot-scope="scope">
            {{ scope.row.create_time | dateTimeFormat }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120px">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="deleteFeedback(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="param.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="param.count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'

export default {
  name: 'feedback_list',
  components: {
    'bread-crumb': BreadCrumb
  },
  created () {
    this.getFeedbackList()
  },
  data () {
    return {
      feedbackList: [],
      total: 0,
      pageTotal: 1,
      param: {
        page: 1,
        count: 10
      }
    }
  },
  methods: {
    async getFeedbackList () {
      const res = await this.$http.get('/admin/feedback/list', this.param)
      if (res.code === 0) {
        this.feedbackList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.param.page = 1
      this.getFeedbackList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getFeedbackList()
    },
    deleteFeedback (id) {
      this.$confirm('是否真的要删除此反馈?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/feedback/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getFeedbackList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.feedback-content {
  line-height: 22px;
  white-space: pre-wrap;
  word-break: break-all;
  text-align: left;
}
</style>
